import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_AnalysisBrief = _resolveComponent("AnalysisBrief")!
  const _component_v_carousel_item = _resolveComponent("v-carousel-item")!
  const _component_v_carousel = _resolveComponent("v-carousel")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "pt-8" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: _ctx.$vuetify.display.smAndDown ? 12 : 10,
            class: "d-flex justify-center align-center mx-auto mb-2"
          }, {
            default: _withCtx(() => [
              _createElementVNode("h1", {
                class: _normalizeClass(_ctx.$vuetify.display.smAndDown ? 'display-2 center-text' : 'display-1')
              }, "Stock analyses in minutes!", 2)
            ]),
            _: 1
          }, 8, ["cols"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: _ctx.$vuetify.display.smAndDown ? 12 : 10,
            class: "d-flex justify-center align-center mx-auto"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                color: "primary",
                class: "text-capitalize",
                variant: "outlined",
                size: "x-large",
                to: { name: 'Sign In' }
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode(" Get Started! ")
                ])),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["cols"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          (_ctx.summaries.length > 0)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: _ctx.$vuetify.display.smAndDown ? 12 : 10,
                class: "d-flex mx-auto"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_carousel, {
                    height: "auto",
                    "show-arrows": _ctx.$vuetify.display.smAndDown ? false : 'hover',
                    cycle: "",
                    "hide-delimiters": "",
                    "hide-delimiter-background": ""
                  }, {
                    prev: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, {
                        color: "primary",
                        class: "prev-btn v-window__left",
                        variant: "outlined",
                        icon: "mdi-chevron-left",
                        size: "x-large",
                        density: "compact",
                        onClick: props.onClick
                      }, null, 8, ["onClick"])
                    ]),
                    next: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, {
                        color: "primary",
                        class: "next-btn v-window__right",
                        variant: "outlined",
                        icon: "mdi-chevron-right",
                        size: "x-large",
                        density: "compact",
                        onClick: props.onClick
                      }, null, 8, ["onClick"])
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summaries, ({ symbol, timestamp, summary }, index) => {
                        return (_openBlock(), _createBlock(_component_v_carousel_item, {
                          key: _ctx.hash({ index, symbol, timestamp }),
                          class: _normalizeClass(_ctx.getPadding() + ' mb-12')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_AnalysisBrief, {
                              symbol: symbol,
                              summary: summary,
                              timestamp: timestamp,
                              cta: _ctx.fullAnalaysisCta
                            }, null, 8, ["symbol", "summary", "timestamp", "cta"])
                          ]),
                          _: 2
                        }, 1032, ["class"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["show-arrows"])
                ]),
                _: 1
              }, 8, ["cols"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}